import React from 'react'
import netflix from 'assets/img/Netflix.svg'
import youtube from 'assets/img/Youtube.svg'
import megogo from 'assets/img/Megogo.svg'
import kinopoisk from 'assets/img/Kinopoisk.svg'
import ivi from 'assets/img/IVI.svg'
import okko from 'assets/img/OKKO.svg'
import PropTypes from 'prop-types'
import Skeleton from '../UI/Skeleton'

class CinemaPlatform extends React.Component {
    handleClick(event) {
        event.preventDefault()
        this.props.props.history.push(`/cinema/${this.props.name}`)
    }

    render() {
        const platforms = { netflix, youtube, megogo, kinopoisk, ivi, okko }
        return (
            <div className="cinema-platform">
                {
                    this.props.skeleton ?
                        <span className="cinema-platform-btn">
                            <Skeleton width={55} height={20} className="mr-10px" image={true} />
                        </span>
                        :
                        <a className="cinema-platform-btn" href={encodeURI(`${this.props.link}${this.props.filmName}`)} target="_blank" rel="noreferrer">
                            <img className="mr-10px" src={platforms[this.props.name]} alt="" />
                        </a>
                }
            </div>
        )
    }
}

CinemaPlatform.propTypes = {
    props: PropTypes.object,
    name: PropTypes.string,
    link: PropTypes.string,
    filmName: PropTypes.string,
    skeleton: PropTypes.bool,
}

export default CinemaPlatform



// WEBPACK FOOTER //
// ./src/components/Cinema/CinemaPlatform.jsx